export default __webpack_public_path__ + "e926d0af93986f04b2ba67907390bcf5.png";